module.exports = {"continue":"Continuar","previous":"Anterior","next":"Seguinte","returnToSummary":"Voltar ao Resumo"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/pt/commons.json
// module id = c1DK
// module chunks = 64